import { BaseModel, type RelationConfig } from './base';

import { Role } from './role';
import { CustomField } from './customField';

import type { Images } from '../types/interfaces/images';
import type { Permissions } from '../types/interfaces/permissions';

export class AdminUser extends BaseModel {
  id!: number
  idEmployee!: number
  firstName!: string
  lastName!: string
  displayName!: string
  email!: string
  phone!: string
  enabled!: boolean
  deleted!: number
  hasImage!: boolean

  images?: Images
  permissions?: Permissions

  role?: Role
  customFields?: CustomField[]

  static override relations(): RelationConfig {
    return {
      role: { type: Role },
      customFields: { type: CustomField }
    };
  }

  override objectID(): string {
    return this.idEmployee?.toString() || '';
  }

  get label(): string {
    return this.displayName;
  }

  get image(): string | null {
    if (this.hasImage) {
      return this.images?.square || null;
    }
    return null;
  }

  get initials(): string {
    return (
      (this.firstName ? this.firstName.charAt(0) : '') +
      (this.lastName ? this.lastName.charAt(0) : '')
    ).toUpperCase();
  }
} 